// extracted by mini-css-extract-plugin
module.exports = {"c_container":"callaction-module--c_container--2AAvd","txt_white":"callaction-module--txt_white--3TFfs"};